import xmlPlugin from "@prettier/plugin-xml/src/plugin.js"

(function () {
    const root =
        typeof globalThis !== "undefined"
            ? globalThis
            : typeof global !== "undefined"
                ? global
                : typeof self !== "undefined"
                    ? self
                    : this || {};

    const plugins = root.prettierPlugins || {};
    plugins.xml = xmlPlugin;
    root.prettierPlugins = plugins;
})();
